import { truckModelsApi } from "./truckModels.api";

export const { useGetTruckModelQuery, useGetTruckModelsQuery, useLazyGetTruckModelQuery, useLazyGetTruckModelsQuery, useLazyGetTruckModelsByBrandQuery } = truckModelsApi;
